import router, { routeCurrent } from '@iez/core/router'
import register from '@iez/core/start/init/register'
import { default as InputImage, route } from './component/'

const imagesByRouteName = {}

export default {
  unmountToPromise: ({ imageWidth, imageHeight, oversampling, image, label }={}) => {
    const name = routeCurrent.name
    if (!imagesByRouteName.hasOwnProperty(name)) {
      imagesByRouteName[name] = null
      router.beforeEach((to, from, next) => {
        if (from.name === name && to.name !== route.name) {
          imagesByRouteName[name] = null
        }
        next()
      })
    }
    const resolve = image => {
      imagesByRouteName[name] = image
    }
    router.push({
      ...route,
      params: {
        resolve,
        imageWidth,
        imageHeight,
        oversampling,
        image,
        label
      }
    })
  },
  resolve: ({ defaultValue }) =>
    imagesByRouteName[routeCurrent.name] || defaultValue,
  setup: () => {
    register({
      pages: {
        InputImage
      }
    })
  }
}
